import React, { useState, useEffect } from "react";
import { Modal, Card } from "react-bootstrap";
import { styleModalComponent } from "./style";
import Separator from "../separator/separator";
import { BsFillCreditCardFill, BsCashCoin } from "react-icons/bs";
import { colors, styleScreenDashboard } from "../../styles/style";
import ButtonCustom from "../buttons/buttonCustom";

/**
 * @param {String} order Información de la orden
 * @param {Boolean} show Control para mostar la modal
 * @param {Function} handleClose Función para cerrar la modal
 * @returns Modal para presentar los detalles de la orden
 */
const ModalCurrentOrder = ({ order, show, handleClose }) => {
  console.log("🚀 ~ file: modalCurrentOrder.js:16 ~ ModalCurrentOrder ~ show", show)
  console.log("🚀 ~ file: modalCurrentOrder.js:16 ~ ModalCurrentOrder ~ order", order)
  //? list products
  const [currentProducts, setCurrentProducts] = useState([]);
  //? address of the order
  const [addressTo, setAddressTo] = useState("");
  const [addressFrom, setAddressFrom] = useState("");
  //? date of the order
  const [date, setDate] = useState("");

  useEffect(() => {
    asignmentAddress();
    sortProducts();
    getDateOrder();
  }, []);

  /**
   * Function to assign address
   */
  const asignmentAddress = () => {
    if (
      order.shop_comments === "WISHES" ||
      order.shop_comments === "SOLUTIONS"
    ) {
      var addresses = [];
      addresses = JSON.parse(JSON.parse(order?.address)) ?? [0].name;

      setAddressFrom(addresses[0]);
      setAddressTo(addresses[1]);
    } else {
      setAddressFrom({ name: order.address });
      setAddressTo({ name: order.shop_id.address_shop });
    }
  };

  /**
   * Function to sort products
   */
  const sortProducts = () => {
    if (order.shop_comments === "SOLUTIONS") {
      let newProd = order.products.items[0];
      let points = JSON.parse(order.products.items[0].comments);
      newProd.comments =
        "Recoger en la primer dirección " +
        points.pointA +
        " para entregar  " +
        points.pointB;
      setCurrentProducts([newProd]);
    } else if (order.shop_comments === "WISHES") {
      //console.log(products);
      let oldFormat = JSON.parse(order.products.items[0].comments);
      let newProds = [];
      oldFormat.forEach((element) => {
        let currProd = {
          id: element.id,
          product_id: {
            id: element.id,
            product_name: element.name,
            netcontent: "NA",
          },
          quantity: element.quantity,
        }; //initialProduct;
        /*  currProd.product_id.product_name = element.name;
                currProd.quantity = element.quantity;
                currProd.id = element.id; */
        newProds.push(currProd);
      });
      setCurrentProducts(newProds);
      //let newProds = products
    } else {
      setCurrentProducts(order.products.items);
    }
  };

  /**
   * Function to get the date of the order
   */
  function getDateOrder() {
    let historyBD = JSON.parse(order.history);
    //console.log("🚀 ~ file: modalCurrentOrder.js ~ line 93 ~ getDateOrder ~ historyBD", historyBD)
    let found = historyBD.findIndex(
      (element) => element.level === "EN PROCESO" && element.status === "LISTO"
    );
    //? found last date of update in order
    if (found > -1) {
      let dateOrder = new Date(historyBD[found].hour).toLocaleString();
      setDate(dateOrder);
    }
  }

  /**List of products */
  const SectionProducts = () => {
    return (
      <div>
        <div style={styleModalComponent.titlesModalContainer}>
          <div className="row">
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Cantidad</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Nombre del producto</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Contenido</Card.Text>
            </div>
          </div>
        </div>
        {currentProducts.map((product, index) => {
          return (
            <div
              key={product.id + index}
              style={styleModalComponent.textContainer}
            >
              <div className="row">
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Title>{product.quantity}</Card.Title>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Text>{product.product_id.product_name}</Card.Text>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Subtitle className="mb-2 text-muted">
                    {product.product_id.netcontent}
                  </Card.Subtitle>
                </div>
              </div>
              {!!product.comments && (
                <>
                  <Separator altStyle={true} />
                  <div className="row">
                    <div
                      className="col"
                      style={styleModalComponent.colsContainer}
                    >
                      <Card.Text>
                        Comentarios{"\n"}
                        {product.comments}
                      </Card.Text>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  /**
   * Function to redirect to maps
   */
  function showTravel() {
    var nameFrom = "";
    var nameTo = "";
    if (
      order.shop_comments === "WISHES" ||
      order.shop_comments === "SOLUTIONS"
    ) {
      //? coordenadas de las direcciones
      var coordsFrom = addressFrom?.coords;
      var coordsTo = addressTo?.coords;
      //? nombre de las direcciones
      nameFrom = addressFrom?.name;
      nameTo = addressTo?.name;

      if (coordsFrom.lenght > 0) {
        window.open(
          `https://www.google.com.mx/maps/dir/${coordsFrom}/${coordsTo}`,
          "_blank"
        );
      } else {
        window.open(
          `https://www.google.com.mx/maps/dir/${nameFrom}/${nameTo}`,
          "_blank"
        );
      }
    } else {
      nameFrom = order.address;
      nameTo = order.shop_id.address_shop;

      window.open(
        `https://www.google.com.mx/maps/dir/${nameFrom}/${nameTo}`,
        "_blank"
      );
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Información de la orden</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={styleScreenDashboard.cardColumn}>
          <Card style={styleScreenDashboard.borderCards}>
            <Card.Body>
              <Card.Title>
                <div className="row">
                  <Card.Text className="col-9">
                    #{order.id.substring(0, 6)}
                    {order.shop_comments === "WISHES"
                      ? " | Niku deseo"
                      : order.shop_comments === "SOLUTIONS"
                      ? " | Niku mandado"
                      : " | " +
                        order.shop_id.shop_name +
                        (order.shop_id.acceptCard ? "" : " (sólo efectivo)")}
                  </Card.Text>
                  <div className="col fs-6">
                    <Card.Text>{date}</Card.Text>
                  </div>
                </div>
              </Card.Title>
              <Separator />
              <div className="row">
                <Card.Text className="col-9 fs-5">
                  Cliente:{" "}
                  {order.customer_id.name + " " + order.customer_id.last_name}
                </Card.Text>
                <Card.Text className="col fs-6" style={{ alignSelf: "center" }}>
                  {order.method_pay !== "EFECTIVO" ? (
                    <div className="row">
                      <p className="col">Tarjeta</p>
                      <BsFillCreditCardFill
                        className="col"
                        size={25}
                        color={colors.GREEN_2_COLOR}
                      />
                    </div>
                  ) : (
                    <div className="row">
                      <p className="col">Efectivo</p>
                      <BsCashCoin
                        className="col"
                        size={25}
                        color={colors.GREEN_2_COLOR}
                      />
                    </div>
                  )}
                </Card.Text>
              </div>
              <div className="row">
                <div className="col-9">
                  <Card.Text>Trayecto</Card.Text>
                  <Card.Text>Desde: {addressFrom.name}</Card.Text>
                  <Card.Text>Hasta: {addressTo.name}</Card.Text>
                </div>
                <div className="col" style={{ alignSelf: "center" }}>
                  <ButtonCustom
                    text={"Ver trayecto"}
                    type={"blue"}
                    functionBtn={showTravel}
                  />
                </div>
              </div>
              <Separator />
              <div className={"row"}>
                <div className={"col-9"}>
                  <Card.Text>Productos</Card.Text>
                </div>
                <SectionProducts />
              </div>
            </Card.Body>
          </Card>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalCurrentOrder;
